import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from "./components/WhatsAppButton";
import FloatingCTA from "./components/FloatingCTA";
import FadeInSection from "./components/FadeInSection";
import DigitalProducts from "./components/DigitalProducts";
import ProductSlider from './components/ProductSlider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomerReviews from './components/CustomerReviews';
import React, { useRef, useState, useEffect } from 'react';





function App() {
  const productInquiryHandler = useRef(null);
  const productSliderResetFunc = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [hasOffers, setHasOffers] = useState(false);

  const setInquiryHandler = (handler) => {
    productInquiryHandler.current = handler;
  };

  const setProductSliderReset = (resetFunc) => {
    productSliderResetFunc.current = resetFunc;
  };

  const handleOffersDetected = (offersExist) => {
    setHasOffers(offersExist);
  };

  const handleBuyNow = (selectedProducts) => {
   // ✅ STEP 1: Normalize to array (single object case)
   console.log("Inside APp.js handle buy now", selectedProducts);
  if (!Array.isArray(selectedProducts)) {
    selectedProducts = [selectedProducts];
  }

  // ✅ STEP 2: Filter out invalid items with quantity <= 0
  const validProducts = selectedProducts.filter(
    (p) => p && p.quantity > 0
  );
  console.log("inside handle buy now valid products", validProducts);
  // ✅ STEP 3: Final fallback validation
  if (!validProducts.length) {
    alert("Please select at least one product.");
    return;
  }

  const messageBody = selectedProducts
    .map(p => `${p.name.trim()} - Qty: ${p.quantity}, Total: ₹${p.price.toFixed(2)}`)
    .join(",\n");
  
  console.log("message: ", messageBody);

  const finalMessage = `Hi, I'm interested in the following products:\n\n${messageBody}`;

  // WhatsApp
  const phoneNumber = "917010716344";
  const encodedMessage = encodeURIComponent(finalMessage);
  const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  window.open(url, '_blank');

  // Set message for WhatsAppButton
  setSelectedProduct(finalMessage);

  // Contact form field
  if (productInquiryHandler.current) {
    productInquiryHandler.current(finalMessage);
  }

    if (productSliderResetFunc.current) {
      productSliderResetFunc.current(); // This will execute the setQuantities({}) in ProductSlider
    }
  };
  return (
    <> 
      <div className="App">
        <Navbar />
        <FadeInSection>
          <HeroSection hasOffers={hasOffers} />
        </FadeInSection>

        <FadeInSection>
          <DigitalProducts onBuyNow={handleBuyNow} setProductSliderReset={setProductSliderReset} onOffersDetected={handleOffersDetected} />
        </FadeInSection>

        <FadeInSection>
          <Gallery />
        </FadeInSection>

        <FadeInSection>
          <CustomerReviews />
        </FadeInSection>

        <FadeInSection>
          <Contact onProductInquiry={setInquiryHandler} />
        </FadeInSection>

        <FadeInSection>
          <About />
        </FadeInSection>

        <FadeInSection>
          <Footer />
        </FadeInSection>


        <WhatsAppButton message={selectedProduct}/>
        <FloatingCTA />
      </div>
    </>
  );
}

export default App;
